import SideBarBlock from './Block';

export default SideBarBlock;
